import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gordita-400-12 text-Text/text_medium" }
const _hoisted_2 = { class: "exists flex flex-row items-center gap-2" }
const _hoisted_3 = { class: "title gordita-400-12 text-Text/text_high" }


import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';

type Props = {
  title: string;
  exists: boolean;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'workload-view-summary-configurations-item',
  props: {
    title: null,
    exists: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "workload-view-summary-configurations-item grow flex items-start gap-3" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(__props.title), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["circle rounded-full w-2 h-2", {
          'bg-System/app_primary': __props.exists,
          'bg-System/app_disabled': !__props.exists,
        }])
        }, null, 2),
        _createElementVNode("div", _hoisted_3, _toDisplayString(__props.exists ? _ctx.$t('workloads.details.summaryTab.configurations.yes') : _ctx.$t('workloads.details.summaryTab.configurations.no')), 1)
      ])
    ]),
    _: 1
  }))
}
}

})